var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icone info dolar" } }, [
        _c("path", {
          attrs: {
            id: "Mask",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M2 12C2 6.477 6.477 2 12 2C17.522 2 22 6.477 22 12C22 17.523 17.522 22 12 22C6.477 22 2 17.523 2 12ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12.6995 17.4854C12.6995 17.5579 12.6874 17.57 12.627 17.57H11.3938C11.3938 17.57 11.3092 17.5458 11.3092 17.4733V16.3247C10.4871 16.3006 9.64076 16.095 9.09672 15.7928C9.02418 15.7444 9 15.6719 9 15.5631V14.0639C9 13.9914 9.07254 13.931 9.13299 13.9914C9.9551 14.6322 11.0311 14.8135 11.7807 14.8135C12.7237 14.8135 13.3282 14.4629 13.3282 13.9189C13.3282 13.3748 12.9655 13.0484 11.6114 12.4923C9.61658 11.7185 9 10.9931 9 9.71159C9 8.51469 9.85838 7.47496 11.3333 7.23317V6.08463C11.3333 6.01209 11.3454 6 11.418 6H12.639C12.7116 6 12.7237 6.01209 12.7237 6.08463L12.772 7.1969C13.4491 7.24526 14.1986 7.39033 14.5734 7.65631C14.6218 7.68049 14.6339 7.72885 14.6339 7.81348V9.24008C14.6339 9.31262 14.5734 9.3368 14.513 9.31262C13.9327 8.87739 13.1952 8.61141 12.1071 8.61141C11.1157 8.61141 10.608 9.03456 10.608 9.53024C10.608 10.0259 10.886 10.3282 12.4214 10.9568C14.5855 11.8152 15.0328 12.6857 15.0328 13.798C15.0328 15.3817 13.715 16.095 12.6995 16.228V17.4733V17.4854Z",
            fill: _vm.color
          }
        }),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "luminance" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "2",
              y: "2",
              width: "20",
              height: "20"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M2 12C2 6.477 6.477 2 12 2C17.522 2 22 6.477 22 12C22 17.523 17.522 22 12 22C6.477 22 2 17.523 2 12ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12.6995 17.4854C12.6995 17.5579 12.6874 17.57 12.627 17.57H11.3938C11.3938 17.57 11.3092 17.5458 11.3092 17.4733V16.3247C10.4871 16.3006 9.64076 16.095 9.09672 15.7928C9.02418 15.7444 9 15.6719 9 15.5631V14.0639C9 13.9914 9.07254 13.931 9.13299 13.9914C9.9551 14.6322 11.0311 14.8135 11.7807 14.8135C12.7237 14.8135 13.3282 14.4629 13.3282 13.9189C13.3282 13.3748 12.9655 13.0484 11.6114 12.4923C9.61658 11.7185 9 10.9931 9 9.71159C9 8.51469 9.85838 7.47496 11.3333 7.23317V6.08463C11.3333 6.01209 11.3454 6 11.418 6H12.639C12.7116 6 12.7237 6.01209 12.7237 6.08463L12.772 7.1969C13.4491 7.24526 14.1986 7.39033 14.5734 7.65631C14.6218 7.68049 14.6339 7.72885 14.6339 7.81348V9.24008C14.6339 9.31262 14.5734 9.3368 14.513 9.31262C13.9327 8.87739 13.1952 8.61141 12.1071 8.61141C11.1157 8.61141 10.608 9.03456 10.608 9.53024C10.608 10.0259 10.886 10.3282 12.4214 10.9568C14.5855 11.8152 15.0328 12.6857 15.0328 13.798C15.0328 15.3817 13.715 16.095 12.6995 16.228V17.4733V17.4854Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "24", height: "24", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }